<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     授权推广
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog class="ei-promote" width="900px" :visible.sync="dialogShow" :modal-append-to-body="false" @close="onDialogClose">
    <span slot="title">
      <span class="font-lg">授权推广</span>
    </span>
    <el-alert type="success" :closable="false" show-icon>
      <p>打开启用推广开关后，可选择默认授权推广收费方案，不选择收费方案则用户需要自行联系厂家购买授权，默认收费方案需在收费方案页面添加。推广启用后，设备监控小程序用户将能看到授权推广页面和推广的收费方案，用户可自行选择开通授权。</p>
    </el-alert>
    <div v-loading="dialogLoading" style="width: 400px; margin: 40px auto 20px">
      <el-form ref="promoteCiot" :model="promoteCiot" :rules="promoteCiotRules" label-position="left" label-width="120px">
        <el-form-item label="是否启用推广">
          <el-switch
            v-model="promoteCiot.wxapp_ciot_ad_enable"
            :active-value="1"
            :inactive-value="0"
            active-color="#07c160"
            inactive-color="#dddddd" />
        </el-form-item>
        <el-form-item v-show="promoteCiot.wxapp_ciot_ad_enable" label="收费方案" prop="schemeid">
          <el-select v-model="promoteCiot.wxapp_ciot_default_schemeid" placeholder="请选择收费方案" style="width: 100%;" clearable>
            <el-option
              v-for="item in schemes"
              :key="item.schemeid"
              :label="item.title"
              :value="item.schemeid">
              <span>{{ item.title }}</span>
              <span v-if="item.scheme_unit === 'year'" class="ml">
                {{ item.scheme_price | currency }} / 年
              </span>
              <span v-if="item.scheme_unit === 'month'" class="ml">
                {{ item.scheme_price | currency }} / 月
              </span>
              <span v-if="item.scheme_unit === 'once'" class="ml">
                {{ item.scheme_price | currency }} / 一次性
              </span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="text-center mb">
      <el-button type="primary" @click="submit('promoteCiot')">立即设置</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { allSchemeApi } from '@/api/ei/eiApi'
import { promoteCiotApi } from '@/api/ei/eiCiotApi'

export default {
  name: 'EiPromote',

  components: {
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      schemes: [],
      dialogLoading: false,
      promoteCiot: {
        wxapp_ciot_ad_enable: null,
        wxapp_ciot_default_schemeid: null
      },
      promoteCiotRules: {
      }
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  watch: {
  },

  created() {
    this.fetchPrmote()
    this.fetchScheme()
  },

  methods: {
    fetchPrmote() {
      this.dialogLoading = true
      promoteCiotApi().then(res => {
        this.dialogLoading = false
        if (res.errno === 0) {
          this.promoteCiot = Object.assign({}, res.data)
          this.promoteCiot.wxapp_ciot_default_schemeid = this.promoteCiot.wxapp_ciot_default_schemeid ? this.promoteCiot.wxapp_ciot_default_schemeid : null
        } else {
          this.$message.error(res.message)
        }
      })
    },

    fetchScheme() {
      allSchemeApi().then(res => {
        if (res.errno === 0) {
          this.schemes = res.data.list
        } else {
          this.$message.error(res.message)
        }
      })
    },

    onDialogClose() {
    },

    submit() {
      this.$confirm('确认保存此次授权推广设置', '提示', {
        type: 'warning'
      }).then(() => {
        promoteCiotApi(this.promoteCiot).then(res => {
          if (!res.errno) {
            this.dialogShow = false
            this.$message.success('授权推广保存设置成功！')
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.new-ciot {
  .el-dialog__body {
    padding: 15px 20px;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
